import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation = () => {
  const publicUrl = process.env.PUBLIC_URL || '';
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('section');
      let current = '';

      sections.forEach(section => {
        const sectionTop = section.offsetTop;
        if (window.scrollY >= (sectionTop - 200)) {
          current = section.getAttribute('id');
        }
      });

      setActiveSection(current);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleNavClick = (e, href) => {
    if (!isHomePage) {
      // If not on home page, navigate to home first
      window.location.href = '/' + href;
      return;
    }
    
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      setMenuOpen(false);
    }
  };

  return (
    <nav>
      <div className="container">
        <Link to="/" className="logo">
          <img src={`${publicUrl}/logo.svg`} alt="Logo" />
          <span>Mespi.dev</span>
        </Link>
        <button className="mobile-menu-btn" onClick={toggleMenu}>☰</button>
        <ul className={`nav-links ${menuOpen ? 'active' : ''}`}>
          <li><Link to="/projekty">Projekty</Link></li>
          {isHomePage && (
            <>
              <li><Link to="#skills" className={activeSection === 'skills' ? 'active' : ''} onClick={(e) => handleNavClick(e, '#skills')}>Umiejętności</Link></li>
              <li><Link to="#contact" className={activeSection === 'contact' ? 'active' : ''} onClick={(e) => handleNavClick(e, '#contact')}>Kontakt</Link></li>
            </>
          )}
          {!isHomePage && (
            <>
              <li><Link to="/#skills">Umiejętności</Link></li>
              <li><Link to="/#contact">Kontakt</Link></li>
            </>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;

